// Shipping extension (admin side): how the product ships.
// The tab is the old catalog editor's ShippingTab, reused as it is — it reads and
// writes through the shared catalog editor (../shared/catalog-editor.jsx).
import { TruckIcon } from "@heroicons/react/24/outline"
import ShippingTab from "./ShippingTab"
import { CatalogEditorProvider, catalogSection, catalogVisible, useCatalogVisibilityContext } from "../shared/catalog-editor"
import { reviewBadge } from "../shared/review-marks"

export const StoreProductExtension = {
  id: "shipping",
  label: "Shipping",
  description: "Weight, packaging and delivery days of a physical product",
  section: {
    component: catalogSection(ShippingTab),
    label: "Shipping",
    icon: TruckIcon,
    // what a reviewer marked here for the vendor (shared/review-marks)
    badge: reviewBadge("shipping"),
    order: 550,
    visible: catalogVisible("shipping"),
  },
  provider: CatalogEditorProvider,
  visibilityContext: useCatalogVisibilityContext,
}
